import {Component, inject} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {Router} from '@angular/router';
import {CardModule} from 'primeng/card';
import {Button} from 'primeng/button';
import {IconLoginComponent} from '@components/icons/icon-login/icon-login.component';

@Component({
  selector: 'app-session-expired',
  standalone: true,
  imports: [
    CardModule,
    NgOptimizedImage,
    Button,
    IconLoginComponent,
  ],
  templateUrl: './session-expired.component.html',
  styleUrl: './session-expired.component.css'
})
export class SessionExpiredComponent {
  private readonly router = inject(Router);

  onAcessar() {
    this.router.navigate(['/auth/login']).then(() => console.info('Redirecionando para login.'));
  }
}
